import React from 'react';
import { ABTestDashboard } from '@/components/ab-testing/ABTestDashboard';

const ABTestingPage: React.FC = () => {
  return <ABTestDashboard />;
};

export default ABTestingPage;